import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Helper standard shadcn/ui per concatenare classi Tailwind con dedup. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
